import React from 'react';
import {
    Grid,
    MenuItem,
    TextField,
    Button,
    FormHelperText,
    InputLabel,
    Select,
    FormControl
} from '@material-ui/core';
import { stylesGenContract } from './stylesGenContract';
import { Controller } from 'react-hook-form';


const FormGenerationContract = ({
    stateForm,
    handleChange,
    onSubmit,
    inputDisabled,
    register,
    handleSubmit,
    control,
    errors,
    dataMaestras,
    getValues,
    contractType,
    formats
}) => {
    
    const classes = stylesGenContract();

    const handleUserKeyPressDocumento = (e) => {
        var form = getValues();
        if (form.documentType !== "PP" && form.documentType !== "CE") {
          let validChars = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0"];
          if (!validChars.includes(e.key)) {
            e.preventDefault();
          }
        }
    };
    
    return (
        <div>
            <form onSubmit={handleSubmit(onSubmit)} className={classes.form} >
                <Grid container>
                    <Grid item xs={12} md={10} lg={10}>
                        <Grid container spacing={2} > 

                            <Grid item xs={12} md={3} lg={3}>
                                <FormControl
                                    variant="outlined"
                                    fullWidth
                                    className={classes.formControlGen}
                                    size="small"
                                    error={
                                    !!errors.hasOwnProperty("documentType") &&
                                    errors["documentType"].message
                                    }
                                >
                                    <InputLabel htmlFor="outlined-select-documentType" shrink={true}>
                                        Tipo de documento *
                                    </InputLabel>
                                    <Controller
                                        fullWidth
                                        control={control}
                                        name="documentType"
                                        inputRef={register}
                                        defaultValue=''
                                        className={!inputDisabled ? classes.inputForm : classes.inputDisabled}
                                        disabled={inputDisabled}
                                        label="Cargo a desempeñar *"
                                        size="small"
                                        notched={true}
                                        inputProps={{
                                            name: "documentType",
                                            id: "outlined-select-documentType",
                                        }}
                                        as={
                                            <Select>
                                                {dataMaestras?.maestras?.tipoDocumnetoIdentificacion.map((res) => (
                                                        <MenuItem
                                                            className={classes.menuItem}
                                                            key={res?.key}
                                                            value={res?.key}
                                                        >
                                                            {res?.value}
                                                        </MenuItem>
                                                    ))}
                                            </Select>
                                        }
                                    />
                                    <FormHelperText style={{color: "#f44336", paddingLeft: 14}}>
                                        {errors.hasOwnProperty("documentType") && errors["documentType"].message}
                                    </FormHelperText>
                                </FormControl>
                            </Grid>

                            <Grid item xs={12} md={3} lg={3}>
                                <FormControl
                                    fullWidth
                                > 
                                    <TextField
                                        InputLabelProps={{ shrink: true }}
                                        inputRef={register}
                                        type="text"
                                        name="document"
                                        defaultValue=""
                                        //onChange={(e) => handleChange(e)}
                                        className={!inputDisabled ? classes.inputForm : classes.inputDisabled}
                                        label="Número Documento *"
                                        variant="outlined"
                                        fullWidth
                                        size="small"
                                        margin="dense"
                                        disabled={inputDisabled}
                                        error={errors.hasOwnProperty('document') && errors['document'].message}
                                        onKeyPress={handleUserKeyPressDocumento }
                                    />
                                    <FormHelperText style={{color: "#f44336", paddingLeft: 14}} >
                                        {errors.hasOwnProperty('document') && errors['document'].message}                          
                                    </FormHelperText> 
                                </FormControl>
                            </Grid>

                            <Grid item xs={12} md={3} lg={3}>
                                <FormControl
                                    variant="outlined"
                                    fullWidth
                                    className={classes.formControlGen}
                                    size="small"
                                    error={
                                        !!errors.hasOwnProperty("idContractTypeFormat") &&
                                        errors["idContractTypeFormat"].message
                                    }
                                >
                                    <InputLabel htmlFor="outlined-select-idContractTypeFormat" shrink={true}>
                                        Tipo de contrato *
                                    </InputLabel>
                                    <Controller
                                        fullWidth
                                        name="idContractTypeFormat"
                                        control={control}
                                        size="small"
                                        defaultValue=""
                                        render={(props) => (
                                            <Select
                                                inputRef={register}
                                                label="Tipo de contrato *"
                                                notched={true}
                                                disabled={inputDisabled}
                                                className={!inputDisabled ? classes.inputForm : classes.inputDisabled}
                                                inputProps={{
                                                    name: "idContractTypeFormat",
                                                    id: "outlined-select-idContractTypeFormat",
                                                }}
                                                value={stateForm?.idContractTypeFormat}
                                                onChange={(e) => {
                                                    props.onChange(e);
                                                    handleChange(e)
                                                }}
                                            >
                                                {contractType?.map(res => (
                                                    <MenuItem
                                                        className={classes.menuItem}
                                                        key={res?.id}
                                                        value={res?.contractTypes}
                                                    >
                                                        {res?.contractTypeDescription}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        )}
                                    />    
                                    <FormHelperText style={{color: "#f44336", paddingLeft: 14}}>
                                    {errors.hasOwnProperty("idContractTypeFormat") && errors["idContractTypeFormat"].message}
                                    </FormHelperText>
                                </FormControl>
                            </Grid>

                            <Grid item xs={12} md={3} lg={3}>
                                <FormControl
                                    variant="outlined"
                                    fullWidth
                                    className={classes.formControlGen}
                                    size="small"
                                    error={!!errors.hasOwnProperty("format") && errors["format"].message}
                                >
                                    <InputLabel htmlFor="outlined-select-format" shrink={true}>
                                        Formato *
                                    </InputLabel>
                                    <Controller
                                        fullWidth
                                        control={control}
                                        name="format"
                                        size="small"
                                        defaultValue=""
                                        inputRef={register}
                                        label="Formato *"
                                        notched={true}
                                        disabled={inputDisabled}
                                        className={!inputDisabled ? classes.inputForm : classes.inputDisabled}
                                        inputProps={{
                                            name: "format",
                                            id: "outlined-select-format",
                                        }}
                                        as={
                                            <Select>
                                                {formats?.map(res => (
                                                    res?.status === 'Activo'
                                                        ?   <MenuItem
                                                                className={classes.menuItem}
                                                                key={res?.id}
                                                                value={res?.id}
                                                            >
                                                                {res?.name}
                                                            </MenuItem>
                                                        : null
                                                ))}
                                            </Select>
                                        }
                                    />    
                                    <FormHelperText style={{color: "#f44336", paddingLeft: 14}}>
                                        { errors.hasOwnProperty("format") && errors["format"].message}
                                    </FormHelperText>
                                </FormControl>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} md={2} lg={2} style={{textAlign: 'center'}}>
                        <Grid >
                            <Button 
                                type="submit" 
                                variant="contained" 
                                className={classes.buttonContinue}
                                disabled={inputDisabled}
                            >
                                Continuar
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
            </form>
        </div>
    )
}

export default FormGenerationContract;
